import React, { useState, useRef, useContext } from 'react'
import module from './FormPersonalInput.module.css'
import { Button, CircularProgress, Grid } from '@mui/material'
import GridItemText from './GridItemText'
import BirthdaySelect from '../../atomic/molecular/BirthDaySelect'
import convertBirthday from '../../../util/convertBirthday'
import { Auth } from 'aws-amplify'
import { RewardSettingContext } from '../../../contexts/RewardSettingContext'

const checkKeys = {
    family_name: "姓",
    given_name: "名",
    birth_year: "生年月日(年)",
    birth_month: "生年月日(月)",
    birth_day: "生年月日(日)",
}

const FormPersonalInput = () => {

    const [imgData, setImgData] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const { setUser } = useContext(RewardSettingContext);

    const handleImageChange = (e) => {
        try {
            if (!e.target.files) {
                setError("ファイルを選択してください");
                return null;
            }

            const file = e.target.files[0];
            const reader = new FileReader();
            reader.onloadend = () => {
                setImgData(reader.result);
            }
            reader.readAsDataURL(file);
        } catch (e) {
            setError("ファイルの読み込みに失敗しました。再度読み込んでください。");
        }
    }

    const clearImage = () => {
        setImgData(null);
    };

    const updateAuthUser = async (data) => {
        try {
            const user = await Auth.currentAuthenticatedUser();
            const birthDate = `${data.birth_year}-${data.birth_month}-${data.birth_day}`;
            const formattedBirthDate = convertBirthday(birthDate);
            await Auth.updateUserAttributes(user, {
                "family_name": data.family_name,
                "given_name": data.given_name,
                "birthdate": formattedBirthDate,
                "custom:finish_manual_ekyc": "true",
            });
            const updatedUser = await Auth.currentAuthenticatedUser();
            setUser(updatedUser);
            alert("本人確認情報を送信しました");
        } catch (e) {
            console.log(e);
            alert("本人確認情報の送信に失敗しました");
        };
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const formValues = new FormData(e.target);
        const data = Object.fromEntries(formValues);
        const emptyKeys = Object.keys(checkKeys).filter((key) => {
            if (!data[key]) {
                return true;
            }
            return false;
        });
        if (emptyKeys.length > 0) {
            const emptyKey = emptyKeys.map((key) => checkKeys[key]).join("、");
            alert(`${emptyKey}を入力してください`);
            setIsLoading(false);
            return null;
        }
        if (!imgData) {
            alert("本人確認書類を選択してください");
            setIsLoading(false);
            return null;
        }
        await updateAuthUser(data);
        setIsLoading(false);
    }

    return (
        <div className={module.container}>
            <div>
                <p>本人確認書類と本人情報を入力してください</p>
            </div>
            {isLoading ? (
                <CircularProgress color='success' />
            ) : (
                <form onSubmit={handleSubmit}>
                    <div className={module.wrapSelectImage}>
                        {imgData ? (
                            <div>
                                <div className={module.wrapPreview}>
                                    <img src={imgData} alt="Preview" className={module.preview} />
                                </div>
                                <div>
                                    <Button variant='outlined' onClick={clearImage}>画像を再度選択する</Button>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div>
                                    <p>本人確認書類を選択</p>
                                </div>
                                {error && (
                                    <div>
                                        <p>{error}</p>
                                    </div>
                                )}
                                <div>
                                    <input type="file" accept="image/*" onChange={handleImageChange} />
                                </div>
                            </div>
                        )}
                    </div>
                    <Grid container spacing={2}>
                        <GridItemText
                            label="姓"
                            name={"family_name"}
                            placeholder={"例：山田"}
                        />
                        <GridItemText
                            label="名"
                            name={"given_name"}
                            placeholder={"例：太郎"}
                        />
                    </Grid>
                    <BirthdaySelect />
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            width: "100%",
                            fontWeight: "bold",
                            borderRadius: "0px",
                            padding: "12px 0px",
                            marginTop: "24px",
                        }}
                        type="submit"
                        disabled={!imgData}
                    >
                        本人確認情報を送信する
                    </Button>
                </form>
            )}
        </div >
    )
}

export default FormPersonalInput